import styled from "styled-components";

const TopbarWrapper = styled.div`
  display: grid;
  grid-template-rows: 40% 60%;
  height: 11em;

  .ant-layout-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding-left: 10px;
    position: relative;
    height: 100%;
  }

  .collapsedMenuPadding {
    padding-right: 10px;
  }

  .topbarHeaderBar {
    background-color: ${props => props.theme?.headerColor ?? "#FFF"};
    color: ${props => props.theme?.headerText ?? "#333"};
  }

  .topbarSalutationContainer {
    background-color: ${props => props.theme?.topbarColor ?? "#FFF"};
    color: ${props => props.theme?.topbarText ?? "#333"};
  }

  .topbarContentLeft {
    .topbarLogo {
      height: 60px;
      padding: 0 5px 5px 5px;
      text-align: center;
      overflow: hidden;
      cursor: pointer;
      display: inline-block;

      img {
        margin: 0 auto;
        max-height: 100%;
        max-width: 100%;
        height: 100%;
        padding-bottom: 5px;
      }
    }
  }

  .topbarContentRight {
    display: flex;
    align-items: center;
    min-width: max-content;
  }

  .collapseSidebarToggle {
    font-size: 2em;
    cursor: pointer;
  }

  .topbarUserIconContainer {
    cursor: pointer;
    .ant-dropdown-trigger {
      cursor: pointer;
    }

    .ant-avatar {
      width: 36px;
      height: 36px;
    }
  }

  .topbarRoleDropdownButton {
    margin-right: 1em;
  }

  .topbarMenuContent {
    margin-right: 1em;
    background-color: ${props => props.theme.headerColor};

    .ant-menu-item a {
      color: ${props => props.theme?.headerText ?? "#333"};
      font-size: ${props => props.theme.text.f18};
    }

    .ant-menu-item-selected a {
      color: ${props => props.theme?.headerSelectedText ?? "#8C8C8C"};
    }
  }

  .salutationParent {
    width: 100%;
  }

  .topAdvisor {
    display: inline-block;
    height: 100%;
    width: 10%;
  }

  .subComponentContainer {
    display: grid;
    grid-template-columns: 0.15fr 0.85fr;
    margin-left: -2px;
    height: 100%;
    align-content: center;
    min-width: 160px;

    > span {
      display: flex;
      justify-content: center;
      align-self: center;
      align-content: center;
      > span {
        display: flex;
        justify-content: center;
        align-self: center;
        align-content: center;
        > svg {
          display: flex;
          justify-content: center;
          align-self: center;
          align-content: center;
        }
      }
    }
  }

  .topbarName {
    padding-top: 4px;
    padding-left: 5px;
    display: grid;
    gap: 2px;
    grid-template-rows: 50% 50%;
    height: 100%;

    .topbarGreeting {
      line-height: normal;
      height: 100%;
      font-weight: 600;
      font-size: ${props => props.theme.text.f18};
      overflow: hidden;
    }

    .topbarInfoMessages {
      height: 100%;
      line-height: 80%;
      color: ${props => props.theme.color["Secondary text"]};
      font-size: ${props => props.theme.text.f16};
      overflow: hidden;
    }
  }

  .topbarSalutation {
    padding-left: 2.2em;
    padding-top: 5px;
    display: grid;
    gap: 2px;
    grid-template-rows: 50% 50%;
    height: 100%;

    .topbarGreeting {
      padding-top: 16px;
      line-height: normal;
      height: 100%;
      font-weight: 600;
      font-size: ${props => props.theme.text.f18};
    }

    .topbarInfoMessages {
      height: 100%;
      line-height: 80%;
      color: ${props => props.theme.color["Secondary text"]};
      font-size: ${props => props.theme.text.f16};
    }
  }

  .topbarLanguageLabel {
    cursor: pointer;
    text-transform: capitalize;
    &:hover {
      color: ${props => props.theme.color.grey["grey-7"]};
    }
    margin-right: 1em;
    font-size: ${props => props.theme.text.f18};
  }

  .topbarLanguageDropdown {
    height: 70%;
    align-self: baseline;
    width: 2em;
    text-align: center;
    margin-top: -3px;
  }

  .topbarDropdownMenu {
    margin: 0 10px 0 15px;
  }

  .collapseSidebarToggle {
    font-size: 2em;
    color: #fff;
  }
`;

export default TopbarWrapper;
